import { fromJS } from 'immutable'
import {
  TIMESHEET_EDIT_REQUEST,
  TIMESHEET_EDIT_SUCCESS,
  TIMESHEET_EDIT_FAILURE,
  TIMESHEET_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case TIMESHEET_EDIT_SUCCESS:
      return state
        .set('timesheets', fromJS(action.payload.createdTimesheet))
        .set('isFetching', false)
        .set('status', 200)
        .set('message', 'Edited Successfully.')
    case TIMESHEET_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('timesheets', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case TIMESHEET_EDIT_RESET:
      return state
        .delete('timesheets')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-edit-reducer.js